<h2 mat-dialog-title>Selector Changes</h2>
<div mat-dialog-content>
  <p>The following changes were automatically made during the aid year switch.</p>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Entity</th>
        <th scope="col">Name</th>
        <th scope="col">Old Selector</th>
        <th scope="col">New Selector</th>
      </tr>
    </thead>
    <tbody>
      @for (aidYearChange of data; track aidYearChange) {
        <tr>
          <td>{{ aidYearChange.entity }}</td>
          <td>{{ aidYearChange.name }}</td>
          <td>{{ aidYearChange.oldSelector }}</td>
          <td>{{ aidYearChange.newSelector }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="onNoClick()" type="button" class="dialog-actions__button">Cancel</button>
  <button mat-button type="button" class="dialog-actions__button copy-button" (click)="copyToClipboard()" [class.copy-button--copied]="copied" aria-label="Copy selector changes table to the clipboard" [attr.aria-describedby]="copyFeedbackMessage ? copyFeedbackId : null">
    {{ copied ? "Copied!" : "Copy to Clipboard" }}
  </button>
  @if (copyFeedbackMessage) {
    <div [id]="copyFeedbackId" role="alert" aria-live="polite" class="copy-feedback">
      {{ copyFeedbackMessage }}
    </div>
  }
</div>
